import { ValidatorType } from '../../types/validator.type';

export class Validator {
  type: ValidatorType;
  param1: unknown;
}
